var _path, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHamberger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "hb",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 10 10",
    stroke: "#eee",
    strokeWidth: 0.6,
    fill: "rgba(0,0,0,0)",
    strokeLinecap: "round",
    style: {
      cursor: "pointer"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2,3L5,3L8,3M2,5L8,5M2,7L5,7L8,7"
  }, /*#__PURE__*/React.createElement("animate", {
    dur: "0.2s",
    attributeName: "d",
    values: "M2,3L5,3L8,3M2,5L8,5M2,7L5,7L8,7;M3,3L5,5L7,3M5,5L5,5M3,7L5,5L7,7",
    fill: "freeze",
    begin: "start.begin"
  }), /*#__PURE__*/React.createElement("animate", {
    dur: "0.2s",
    attributeName: "d",
    values: "M3,3L5,5L7,3M5,5L5,5M3,7L5,5L7,7;M2,3L5,3L8,3M2,5L8,5M2,7L5,7L8,7",
    fill: "freeze",
    begin: "reverse.begin"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    stroke: "none"
  }, /*#__PURE__*/React.createElement("animate", {
    dur: "2s",
    id: "reverse",
    attributeName: "width",
    begin: "click"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    stroke: "none"
  }, /*#__PURE__*/React.createElement("animate", {
    dur: "0.001s",
    id: "start",
    attributeName: "width",
    values: "10;0",
    fill: "freeze",
    begin: "click"
  }), /*#__PURE__*/React.createElement("animate", {
    dur: "0.001s",
    attributeName: "width",
    values: "0;10",
    fill: "freeze",
    begin: "reverse.begin"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamberger);
export default __webpack_public_path__ + "static/media/hamberger.b69fd46920eda25f8741e7195b2fbacb.svg";
export { ForwardRef as ReactComponent };